import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import { Icon } from 'js/design_system/Icon';
import GTranslateIcon from 'js/design_system/icons/g_translate.svg';
import { Tooltip } from 'js/design_system/new_tooltip/Tooltip';
import { t } from 'js/intl/t';
import 'js/i18n/page_translations/liswp_blocks/en.wjs';

const Note = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-xs-8, 8px);
  color: var(--text-primary, #141413);
`;

const TitlesNote = styled(Note)`
  gap: var(--spacing-xs-4, 4px);
  padding: 6px 0;
`;

// The design caps the tooltip at 300px, padding included.
const TooltipText = styled(Body).attrs({ size: 'sm' })`
  display: block;
  max-width: calc(
    300px - 2 * var(--button-sm-standard-top-bottom-padding, 12px)
  );
`;

const TitleIcon = styled.span`
  display: inline-flex;
  color: var(--text-link, #0645b1);
`;

/** "Translated into <this page's lang>", for a page shown in the reader's lang. */
export const PageTranslatedNote: React.FC = () => (
  <Note>
    <Icon name="language" size={18} />
    <Body size="sm" bold>
      {t('liswp_blocks.translation_notes.page_translated')}
    </Body>
  </Note>
);

/** Above the pack rows when their titles are machine-translated. */
export const TitlesTranslatedNote: React.FC = () => (
  <TitlesNote>
    <GTranslateIcon svgProps={{ width: 18, height: 18, 'aria-hidden': true }} />
    <Body size="sm">
      {t('liswp_blocks.translation_notes.titles_translated')}
    </Body>
  </TitlesNote>
);

/** Beside a pack row whose title was machine-translated. */
export const TitleTranslatedIcon: React.FC = () => {
  const label = t('liswp_blocks.translation_notes.title_translated_tooltip');
  return (
    <Tooltip render={() => <TooltipText>{label}</TooltipText>}>
      {/* Rows sit inside a clickable panel that starts a download; tapping
          the icon should only show the tooltip. */}
      <TitleIcon
        role="img"
        aria-label={label}
        tabIndex={0}
        onClick={(e) => e.stopPropagation()}
      >
        <Icon name="language" size={18} />
      </TitleIcon>
    </Tooltip>
  );
};
